import { render, staticRenderFns } from "./MatchupCount.vue?vue&type=template&id=4400b559&"
import script from "./MatchupCount.vue?vue&type=script&lang=js&"
export * from "./MatchupCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports